import { IEmployeeApiPort } from '@personnel/application/ports/IEmployeeApiPort';
import { EmployeeDetailRequestDto, EmployeeDetailDto } from '@personnel/application/dtos';

export const getEmployeeByUuidUseCase = (props: { apiPort: IEmployeeApiPort }) => {
  const { apiPort } = props;

  const execute = async (request: EmployeeDetailRequestDto): Promise<EmployeeDetailDto> => {
    const employeeResponse = await apiPort.getEmployeeByUuid(request);
    return employeeResponse;
  };

  return {
    execute,
  };
};
